import API from "../../API/api";

export const fetchArchive = async () => {
  const res = await API.get('/archive');
  return res.data;
};

export const addToArchive = async (data) => {
  const res = await API.post('/archive', data);
  return res.data;
};